import React from 'react';
import { SettingAccountPage } from '../Pages/Settings/SettingAccountPage';
import SettingPasswordPage from '../Pages/Settings/SettingPasswordPage';
import NotificationPage from '../Pages/Notification/NotificationPage';
import NewFeaturePage from '../Pages/Notification/NewFeaturePage';

const SettingRouter = [
  {
    path: '/change-password',
    element: <SettingPasswordPage />,
  },
  {
    path: '/newfeature',
    element: <NewFeaturePage />,
  },
  {
    path: '/notification',
    element: <NotificationPage />,
  },
  {
    path: '/settings',
    element: <SettingAccountPage />,
  }
];


export default SettingRouter;
